import { useContext, useEffect, useState } from "react";
import './index.scss';

import { Dropdown, Input, Modal } from "components/common"
import { ActiveShipmentsContext, DocumentsContext, HomeContext, ModalContext } from "contexts";
import { useForm } from "react-hook-form";
import { getErrorMessage } from "utils";
import { useLocation } from "react-router-dom";
import { StatusTradeTrust } from "actions";


export const DirectEndorsement = ({ open, onCancel }) => {
    const { handleSubmit,register, errors} = useForm();
    const [loadingOwner] = useState(false);
    const [loadingHolder] = useState(false);
    const { wallets } = useContext(ActiveShipmentsContext);
    const { doDirectEndorsementChain, documentInfo} = useContext(DocumentsContext);
    const { walletVerify, setCallbackParties, setPleaseAwait, setStatusBlockChain, setCurrentStatus } = useContext(HomeContext);
    const { setDirectEndorsement } = useContext(ModalContext);
    // const { invokingParty } = useContext(HomeContext);
    const [walletSelectedOwner, setWalletSelectedOwner] = useState();
    const [walletSelectedHolder, setWalletSelectedHolder] = useState();
    const [walletsData, setWalletsData] = useState([]);

    const location = useLocation();
    const pathnameArr = location.pathname.split('/');
    const docId = pathnameArr[pathnameArr.length - 1];

    const handleConfirm = (data) => {
        const payload = {
            merkleRoot:documentInfo?.merkleRoot,
            newHolder:walletSelectedHolder?.address,
            newOwner:walletSelectedOwner?.address,
            organizationId:walletVerify?.orgId,
            tokenRegistryAddress:documentInfo?.tokenRegistryAddress,
            walletPassword:documentInfo?.walletPassword,
            isDemo:false
        };
        if(docId){
            doDirectEndorsementChain(docId, payload, walletVerify?.address, "Ethereum", walletVerify?.orgId, (data) => {
                if(data){
                    setPleaseAwait(true);
                    setCallbackParties(true);
                    setStatusBlockChain([{key: 6, value: 'New owner endorsement started'}]);
                    setCurrentStatus(StatusTradeTrust.NEW_OWNER_ENDORSEMENT_STARTED);
                    setDirectEndorsement(false);
                }
            });
        }
    }

    const handlSelectHolder = (option) => {
        setWalletSelectedHolder(option);
    }

    const handlSelectOwner = (option) => {
        setWalletSelectedOwner(option);
    }

    const handleSearchHolder = (value) => {
        let newArrayWallets = walletsData.filter(w => w?.accountName?.toLowerCase().includes(value?.toLowerCase()));
        if (value) {
            setWalletsData(newArrayWallets);
        } else {
            setWalletsData(wallets);
        }
    }
    const handleSearchOwner = (value) => {
        let newArrayWallets = walletsData?.filter(w => w?.accountName?.toLowerCase().includes(value?.toLowerCase()));
        if (value) {
            setWalletsData(newArrayWallets);
        } else {
            setWalletsData(wallets);
        }
    }

    /*eslint-disable */
    useEffect(() => {
        setWalletsData(wallets);
    }, []);
    /*eslint-enable */
    return (
        <Modal
            className="tr__Modal_DirectEndorsement"
            open={open}
            title="Direct endorsement"
            onCancel={onCancel}
            submitButton
            submitButtonLabel="Confirm"
            isBackDropClickable={false}
            renderForm={children => (
                <form onSubmit={handleSubmit(handleConfirm)}>
                    {children}
                </form>
            )}
        >
            <Dropdown
                className="select"
                icon="icon-chevron-down"
                iconPosition="right"
                mode="input"
                name="ownerAccount"
                label={"Select owner's account *"}
                options={walletsData?.map(type => {
                    return {
                        _id: type._id,
                        key: type._id,
                        address: type.encWallet.address,
                        value: type.accountName + ` (${type.encWallet.address})`,
                        orgId: type.orgId
                    }
                })}
                onChange={option => handlSelectOwner(option)}
                onInputChange={handleSearchOwner}
                placeholder="Select owner's account"
                dropdownPosition="center"
                searchLoading={loadingOwner}
                defaultValue={""}
                refs={register({ required: true })}
                error={!!errors.ownerAccount}
                errorMessage={getErrorMessage(errors.ownerAccount, "ownerAccount")}
            />
            <Input
                label="Owner account address *"
                placeholder="Owner account address"
                name="ownerAccountAddress"
                disabled={true}
                value={walletSelectedOwner?.address}
                className="input_value_address"
                refs={register({ required: true })}
                error={!!errors.ownerAccountAddress}
                errorMessage={getErrorMessage(errors.ownerAccountAddress, "ownerAccount")}
            />
            <Dropdown
                className="select_holder"
                icon="icon-chevron-down"
                iconPosition="right"
                mode="input"
                name="holderAccount"
                label={"Select holder's account *"}
                options={walletsData?.map(type => {
                    return {
                        _id: type._id,
                        key: type._id,
                        address: type.encWallet.address,
                        value: type.accountName + ` (${type.encWallet.address})`,
                        orgId: type.orgId
                    }
                })}
                onChange={option => handlSelectHolder(option)}
                onInputChange={handleSearchHolder}
                placeholder="Select owner's account"
                dropdownPosition="center"
                searchLoading={loadingHolder}
                defaultValue={""}
                refs={register({ required: true })}
                error={!!errors.holderAccount}
                errorMessage={getErrorMessage(errors.holderAccount, "holderAccount")}
            />
            <Input
                label="Holder account address *"
                placeholder="Owner account address"
                name="holderAccountAdress"
                disabled={true}
                value={walletSelectedHolder?.address}
                className="input_value_address"
                refs={register({ required: true })}
                error={!!errors.holderAccountAdress}
                errorMessage={getErrorMessage(errors.holderAccountAdress, "ownerAccount")}
            />
        </Modal>
    )
}